var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCheckCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#e43a36",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7988 7.54695L9.79883 19.547C9.69431 19.6518 9.57012 19.735 9.43337 19.7918C9.29663 19.8486 9.15002 19.8778 9.00195 19.8778C8.85389 19.8778 8.70728 19.8486 8.57053 19.7918C8.43378 19.735 8.30959 19.6518 8.20508 19.547L2.95508 14.297C2.85043 14.1923 2.76742 14.0681 2.71078 13.9313C2.65415 13.7946 2.625 13.6481 2.625 13.5001C2.625 13.3521 2.65415 13.2055 2.71078 13.0688C2.76742 12.9321 2.85043 12.8078 2.95508 12.7032C3.05972 12.5986 3.18396 12.5155 3.32069 12.4589C3.45741 12.4023 3.60396 12.3731 3.75195 12.3731C3.89994 12.3731 4.04649 12.4023 4.18322 12.4589C4.31995 12.5155 4.44418 12.5986 4.54883 12.7032L9.00289 17.1573L20.207 5.95508C20.4183 5.74373 20.7049 5.625 21.0038 5.625C21.3027 5.625 21.5894 5.74373 21.8007 5.95508C22.012 6.16642 22.1308 6.45307 22.1308 6.75195C22.1308 7.05084 22.012 7.33748 21.8007 7.54883L21.7988 7.54695Z",
    fill: "#4F5262"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckCircle);
export default __webpack_public_path__ + "static/media/icon-check-circle.d1355195a2a9f8c2d0f38ab56362d357.svg";
export { ForwardRef as ReactComponent };